import ErrorPage from "@/components/ErrorPage";
import FarmSkeleton from "../../components/skeletons/FarmSkeleton";
import type { ChildrenType } from "@/types/types";
import { useContext, useEffect, useState } from "react";
import { FarmContext } from "@/contexts/farm-context";
import { getFarmUserRequest } from "@/apis/farms-api";

export default function FarmContextPage({ children }: ChildrenType) {
    const { farm, setFarm } = useContext(FarmContext);
    const [isLoading, setIsLoading] = useState(!farm);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getFarmUserRequest();
                setFarm(res.data);
            } catch (error) {
                console.error("Failed get user farm:", error);
                setError(true);
            } finally {
                setIsLoading(false);
            }
        };
        if (!farm) {
            fetchData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) return <FarmSkeleton />;
    if (error) return <ErrorPage />;

    return <>{children}</>;
}
